import React from 'react'
import { Message } from 'semantic-ui-react'

const NoComparablePropertyWarning = ({ header, content }: { header: string, content: string }) => {
  return (
    <Message warning
             header={header}
             content={content}
    />
  )
}

export default NoComparablePropertyWarning
